import { FacilityTypeEnum } from '../../facility-types/enums/facility-type';

class Facility {
  id?: string;

  name = '';

  type: FacilityTypeEnum = FacilityTypeEnum.other;

  officeIds: string[] = [];
}

export default Facility;
